<template>
  <div class="integration-list-grid py-4 group">
    <div class="flex items-center">
      <div class="flex-none mr-4 w-10 h-10 p-1 rounded
                  flex items-center justify-center"
           :style="{background:provider.bank.color_bg}">
        <img :src="provider.bank.icon || provider.bank.logo_url" :alt="`${provider.bank.name}_logo`">
      </div>
      <div class="text-text-secondary text-sm leading-relaxed">
        {{ provider.bank.alias || provider.bank.name }}
      </div>
    </div>
    <div class="flex items-center justify-end">
      <div class="w-9-5 h-9-5 flex justify-center items-center rounded ml-1 bg-border-hover text-sm text-text"
           v-if="accountsLength">
        <font-awesome-icon v-if="provider.status === 'inactive'" icon="circle-notch" spin/>
        <div v-else>{{ accountsLength }}</div>
      </div>
    </div>
    <div class="flex items-center justify-end">
      <div class="w-9-5 h-9-5 flex justify-center items-center rounded ml-1 bg-border-hover text-sm text-text"
           v-if="accountsLength">
        <font-awesome-icon v-if="provider.status === 'inactive'" icon="circle-notch" spin/>
        <div v-else>{{ activeAccountsLength }}</div>
      </div>
    </div>
    <div class="text-right text-2sm text-text-secondary">
      {{ updatedFormatted }}
    </div>
    <div v-if="!currentUserIsWatcher"
         class="flex items-center justify-end opacity-0 group-hover:opacity-100 transition duration-200 ">
<!--      <IconReset class="text-icon transition duration-200 cursor-pointer"-->
<!--                 :class="refreshAvailable ? 'hover:text-icon-hover' : ''"-->
<!--                 v-tooltip="!this.disabled ? refreshTooltip : ''"-->
<!--                 @click.native="!disabled && $emit('refresh')"/>-->
      <IconEdit class="ml-4 text-icon hover:text-icon-hover transition duration-200 cursor-pointer"
                @click.native="$emit('edit')"/>
    </div>
  </div>
</template>

<script>
import IconEdit from "@/components/icons/IconEdit";
import IconReset from "@/components/icons/operationIcons/IconReset";
import {mapGetters} from "vuex";

export default {
  name: "IntegrationsListItem",
  components: {IconReset, IconEdit},
  props: {
    disabled: Boolean,
    provider: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      secondsBeforeRefreshAvailable: null,
    }
  },
  computed: {
    ...mapGetters('space', ['currentUserIsWatcher']),
    accountsLength() {
      return this.provider.accounts.length;
    },
    activeAccountsLength() {
      return this.provider.accounts.filter(account => !!account.connected_to).length;
    },
    refreshAvailable() {
      return this.secondsBeforeRefreshAvailable <= 0;
    },
    refreshTooltip() {
      if (this.refreshAvailable) return this.$t('refreshTip')
      if (!this.disabled) {
        let moment = this.$moment.unix(this.provider.next_refresh_at),
            date = moment.format('DD.MM.YYYY'),
            time = moment.format('HH:mm');
        return this.$t('refreshWillBeAvailable', {date,time})
      }
      return this.$t('syncIsUnavailable')
    },
    updatedFormatted() {
      return this.$moment.unix(this.provider.updated_at).format('DD.MM.YYYY HH:mm')
    }
  },
  methods: {
    setTimer() {
      if (this.provider.next_refresh_at) {
        this.secondsBeforeRefreshAvailable = this.$moment.unix(this.provider.next_refresh_at).diff(this.$moment(), 'seconds')
      }
    },
  },
  watch: {
    secondsBeforeRefreshAvailable: {
      immediate: true,
      handler(val) {
        if (!!val && val >= 0) {
          setTimeout(() => {
            this.secondsBeforeRefreshAvailable -= 60;
          }, 1000 * 60)
        }
      }
    },
    nextRefreshAt: {
      immediate: true,
      handler: 'setTimer'
    }
  },
  i18n: {
    messages: {
      en: {
        refreshTip: 'Refresh connection',
        refreshWillBeAvailable: 'Synchronization will be available on {date} at {time}',
        syncIsUnavailable: 'Synchronization is unavailable'
      },
      ru: {
        refreshTip: 'Обновить подключение',
        refreshWillBeAvailable: 'Синхронизация будет доступна {date} в {time}',
        syncIsUnavailable: 'Синхронизация недоступна'
      },
    }
  }
}
</script>